import { Link, useNavigate } from "react-router-dom";
import "./home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, { Autoplay } from "swiper/core";
import { useEffect, useState } from "react";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

function Home() {
    const url = `${process.env.REACT_APP_API_URL}/auth/getUser`;
    SwiperCore.use([Autoplay]);
    const swiperParams = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    };
    const swiperGame1 = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 1.6,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        grabCursor: true
    };
    const swiperGame2 = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 2,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        grabCursor: true
    };
    const swiperGame3 = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 3.2,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        grabCursor: true
    };
    const swiperGame4 = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 4,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        grabCursor: true
    };
    const swiperGame5 = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 5.4,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        grabCursor: true
    };
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [bet, setBet] = useState(JSON.parse(localStorage.getItem("xsmb")));
    const navigate = useNavigate();
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify != res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
        axios
            .get(url, {})
            .then((res) => {
                setProfile(res.data.data);
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);
    /*const date0 = new Date();
    const currentHour = date0.getHours();
    const [dateMT, setDateMT] = useState(date0.getDay());
    const [dataMT, setDataMT] = useState();
    const [imageMT, setImageMT] = useState([]);
    const handleChangeMT = (e) => {
        setDateMT(e.target.value);
    };
    const [dateMN, setDateMN] = useState(date0.getDay());
    const [dataMN, setDataMN] = useState([]);
    const [imageMN, setImageMN] = useState([]);
    const handleChangeMN = (e) => {
        setDateMN(e.target.value);
    };
    useEffect(() => {
        if (dateMT == 0) {
            if (currentHour < 18) {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            } else {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            }
        }
        if (dateMT == 1) {
            if (currentHour < 18) {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            } else {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            }
        }
        if (dateMT == 2) {
            if (currentHour < 18) {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            } else {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            }
        }
        if (dateMT == 3) {
            if (currentHour < 18) {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            } else {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            }
        }
        if (dateMT == 4) {
            if (currentHour < 18) {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            } else {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            }
        }
        if (dateMT == 5) {
            if (currentHour < 18) {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            } else {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            }
        }
        if (dateMT == 6) {
            if (currentHour < 18) {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            } else {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            }
        }
    }, [dateMT]);
    useEffect(() => {
        if (dateMN == 0) {
            if (currentHour < 17) {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            } else {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            }
        }
        if (dateMN == 1) {
            if (currentHour < 17) {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            } else {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            }
        }
        if (dateMN == 2) {
            if (currentHour < 17) {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            } else {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            }
        }
        if (dateMN == 3) {
            if (currentHour < 17) {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            } else {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            }
        }
        if (dateMN == 4) {
            if (currentHour < 17) {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            } else {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            }
        }
        if (dateMN == 5) {
            if (currentHour < 17) {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            } else {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            }
        }
        if (dateMN == 6) {
            if (currentHour < 17) {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            } else {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            }
        }
    }, [dateMN]);*/

    function launchGame(params) {
        if (profile === null) {
            navigate("/login");
            return;
        }
        if (isLoading == true) return;
        const form = {
            ...params,
            username: profile?.username
        };
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/login`, form)
            .then((res) => {
                let url = res.data.data.url;
                if (form.title == "SportsBook") {
                    url = `https:${url}&lang=vi-vn&oddstyle=MY&theme=sbo&oddsmode=double&device=d`;
                } else if (form.title == "Casino") {
                    url = `https:${url}&locale=vi-vn&device=d&loginMode=1&productId=0`;
                } else if (form.title == "VirtualSports") {
                    url = `https:${url}&lang=vi-vn`;
                } else if (form.title == "SeamlessGame") {
                    url = `https:${url}&gpid=${params.gpid}&gameid=${params.gameId}&lang=vi-vn&device=d`;
                } else if (form.title == "ThirdPartySportsBook") {
                    url = `https:${url}&gpid=${params.gpid}&gameid=0&lang=vi-vn&device=d`;
                }
                window.location.href = url;
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData.access == false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                } else {
                    swal(err.response.data.message, "", "error");
                }
                //swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã có lỗi xảy ra", "error");
            });
    }
    const [isShow, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [yoGame, setYoGame] = useState(false);
    const [yoPopup, setYoPopup] = useState(false);
    const [yoType, setYoType] = useState(1);
    const [yoMoney, setYoMoney] = useState(0);
    const [yoBalance, setYoBalance] = useState(0);
    const openYoGame = () => {
        if (profile === null) {
            return navigate("/login");
        }
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/logingame`)
            .then((res) => {
                setYoGame(res.data.data);
                setYoBalance(res.data.data?.AccountInfo?.Balance);
                setYoPopup(true);
                setLoading(false);
            })
            .catch((err) => {
                swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã xảy ra lỗi", "error");
                setLoading(false);
            });
    };
    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitYoGame = async () => {
        if (profile === null) {
            return navigate("/login");
        }
        if (isSubmitting) {
            return swal("Thông báo", "Bạn thao tác quá nhanh", "warning");
        }
        setLoading(true);
        const transactionAmount = Number(yoMoney?.replaceAll(".", "")?.replaceAll(",", ""));
        if (transactionAmount < 0) {
            setLoading(false);
            return swal("Chú ý", "Vui lòng nhập số tiền cần giao dịch", "warning");
        }
        const formData = {
            amount: transactionAmount,
            type: yoType
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/transfergame`, formData)
            .then((res) => {
                axios
                    .get(url, {})
                    .then((res) => {
                        setProfile(res.data.data);
                        localStorage.setItem("profile", JSON.stringify(res.data.data));
                    })
                    .catch((err) => localStorage.removeItem("user"));
                swal(yoType == 1 ? "Nạp tiền thành công" : "Rút tiền thành công", "", "success");
                setYoBalance(res.data.data.new_balance);
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
                setLoading(false);
            })
            .catch((err) => {
                swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã xảy ra lỗi", "error");
                setLoading(false);
                setIsSubmitting(false);
            });
    };
    if (url.length != 41) return;
    return (
        <>
            {isLoading == true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}
            {swiperParams && notify && (
                <div className="bg-black">
                    <div className="box-slide" style={{ overflow: "hidden" }}>
                        <Swiper {...swiperParams}>
                            {notify.map((item, index) => (
                                <>
                                    {index > 1 && item.title !== "marquee" && item.title !== "popup" && item.isShow === true ? (
                                        <SwiperSlide>
                                            <img alt={item.title.replace("}", "").replace("{", "")} src={item.image} />
                                        </SwiperSlide>
                                    ) : null}
                                </>
                            ))}
                        </Swiper>
                    </div>
                    {/*<div className="container" style={{ maxWidth: "800px", margin: "30px auto 0" }}>
                        <div className="box-miba">
                            <div className="box-miba-left" onClick={() => navigate("/xsmb/lo2")}>
                                <img alt="" src={require("../../images/xs3mien/mienbac.png")} style={{ maxWidth: "200px" }} />
                            </div>
                            <div className="box-miba-right">
                                <div className="box-text">Miền Bắc</div>
                                <div className="box-text">Ngày: {bet?.issueList[0]?.turnNum}</div>
                                <div style={{ display: "flex" }}>
                                    <div className="box-miba-kq" style={{ width: "60%" }}>
                                        {bet?.issueList[0]?.openNum.split(",").map((x) => (
                                            <div className="ball">
                                                <img alt="" src={`/images/ball/${x}.png`} />
                                            </div>
                                        ))}
                                    </div>
                                    <div className="dat-cuoc" onClick={() => navigate("/xsmb/lo2")} style={{ width: "25%", marginLeft: "15%" }}>
                                        Đặt cược
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-title" onClick={() => navigate("/lottery")}>
                        Miền Nam
                    </div>
                    <div className="list-game-xs">
                        {dataMN?.map((item, index) => (
                            <>
                                <Link to={`/xsmn/lo2/${item}`} key={item}>
                                    <img alt="" src={require(`../../images/xs3mien/${imageMN[index]}.png`)} className="img-xs" />
                                </Link>
                            </>
                        ))}
                    </div>
                    <div className="section-title" onClick={() => navigate("/lottery")}>
                        Miền Trung
                    </div>
                    <div className="list-game-xs">
                        {dataMT?.map((item, index) => (
                            <>
                                <Link to={`/xsmt/lo2/${item}`} key={item}>
                                    <img alt="" src={require(`../../images/xs3mien/${imageMT[index]}.png`)} className="img-xs" />
                                </Link>
                            </>
                        ))}
                    </div>*/}
                </div>
            )}
            <div className="container">
                <div className="section-title2">YoGame</div>
                <Swiper {...swiperGame5}>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_baucua.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_tx.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_txmd5.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_sicbo.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_minpoker.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_baccarat.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_maubinh.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_thantai.png")} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div onClick={openYoGame} className="open-yogame">
                            <img src={require("../../images/dx_tayduky.png")} />
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="container">
                <div className="section-title" onClick={() => navigate("/lottery")}>
                    Live Casino
                </div>
                <Swiper {...swiperGame3}>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../images/games/dg.png")} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "1030" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../images/games/wm.png")} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "0" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../images/games/s2.png")} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "7" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../images/games/evolution.png")} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "20" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="container">
                <div className="section-title" onClick={() => navigate("/sports")}>
                    Thể thao
                </div>
                <Swiper {...swiperGame2}>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../images/games/sports_fb_sub.png")} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "ThirdPartySportsBook", gameId: "0", gpid: "1015" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../images/games/sports_sabasports_sub.png")} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SportsBook" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="container">
                <div className="section-title" onClick={() => navigate("/pvp")}>
                    Game bài
                </div>
                <Swiper {...swiperGame1}>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../image/BOLE.png")} style={{ borderRadius: "25px", width: "100%" }} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "1050" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../image/KM.png")} style={{ borderRadius: "25px", width: "100%" }} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "1033" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="box-game">
                            <div className="box-game-image">
                                <img src={require("../../image/MP.png")} style={{ borderRadius: "25px", width: "100%" }} />
                            </div>
                            <div className="box-game-play" onClick={() => launchGame({ title: "SeamlessGame", gameId: "0", gpid: "1009" })}>
                                <span className="box-game-start">Chơi ngay</span>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
                {/*<div className="section-title2">Mini Game</div>
                <Swiper {...swiperGame4}>
                    <SwiperSlide>
                        <Link to="/xs75s/lo2">
                            <img alt="" src={require(`../../images/mb75s.png`)} className="img-xs" />
                        </Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link to="/xs120s/lo2">
                            <img alt="" src={require(`../../images/st2p.png`)} className="img-xs" />
                        </Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link to="/xd45s">
                            <img alt="" src={require(`../../images/xd45s.png`)} className="img-xs" style={{ transform: "scale(1.2)" }} />
                        </Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link to="/xd60s">
                            <img alt="" src={require(`../../images/xd1p.png`)} className="img-xs" style={{ transform: "scale(1.2)" }} />
                        </Link>
                    </SwiperSlide>
                </Swiper>*/}
                <div style={{ height: "50px" }}></div>
            </div>
            {yoPopup === true && yoGame && profile ? (
                <div className="popup-backdrop">
                    <div className="popup-main">
                        <div className="popup-close-top" onClick={() => setYoPopup(false)}>
                            <CloseIcon sx={{ fontSize: "26px", color: "#fff" }} />
                        </div>
                        <div className="popup-header">VIN79CLUB</div>
                        <div className="popup-content">
                            <ul className="tab-navigation tab-game">
                                <li className={yoType === 1 ? "item active" : "item"} onClick={() => setYoType(1)}>
                                    Nạp tiền
                                </li>
                                <li className={yoType === 2 ? "item active" : "item"} onClick={() => setYoType(2)}>
                                    Rút tiền
                                </li>
                            </ul>
                            <div className="form-sibo">
                                <input
                                    type="text"
                                    value={yoMoney}
                                    onClick={() => setYoMoney(null)}
                                    onChange={(e) => setYoMoney(Number(e.target.value.replaceAll(".", "").replaceAll(",", "")).toLocaleString("vi-VN"))}
                                    placeholder="Nhập số tiền"
                                />
                                <button onClick={submitYoGame}>Xác nhận</button>
                            </div>
                            <div style={{ textAlign: "center", margin: "10px 0 0" }}>
                                Số dư sảnh: <b>{yoBalance?.toLocaleString("vi-VN")}</b>
                            </div>
                            <div style={{ textAlign: "center", margin: "10px 0 0" }}>
                                Số dư tài khoản: <b>{profile?.money?.toLocaleString("vi-VN")}</b>
                            </div>
                            <button className="open-game" onClick={() => (window.location.href = `https://vin79club.top?token=${yoGame?.Token}`)}>
                                Vào game
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
}
export default Home;
